import "./TitleSection.scss";
import clsx from "clsx";
import { MoreActions } from "@/icons";
import { ElementType, PropsWithChildren, ReactNode, useState } from "react";
import { ActionsPopup, Row } from "@/components";
import { HeadingLevel } from "@/types/headings";
import { ArrowLink } from "../ArrowLink";

type TitleSectionProps = PropsWithChildren<{
  action1?: ReactNode;
  action2?: ReactNode;
  mainButton?: ReactNode;
  secondaryButton?: ReactNode;
  titleSection: string;
  subtitle?: string | ReactNode;
  classNameTitle?: string;
  borderBottom?: boolean;
  isMoreOption?: boolean;
  handleMoreOption?: () => void;
  titleTag?: HeadingLevel;
  gotoLinkHref?: string;
  gotoLinkLabel?: string;
  gotoLinkAsLink?: ElementType | "a";
}>;

export const TitleSection = ({
  action1,
  action2,
  mainButton,
  secondaryButton,
  titleSection,
  subtitle,
  classNameTitle,
  borderBottom = true,
  titleTag: TitleTag = "h1",
  gotoLinkHref,
  gotoLinkLabel,
  gotoLinkAsLink = "a",
}: TitleSectionProps) => {
  const [openActions, setOpenActions] = useState(false);

  const popupActions = [action1, action2].filter(Boolean);
  console.log('popupActions', popupActions)
  return (
    <div>
      <div
        className={clsx(
          "ui-title-section-container",
          borderBottom ? "" : "no-border-bottom",
        )}
      >
        <div className="ui-title-row">
          <div className="ui-title-container">
            <TitleTag
              className={clsx(
                classNameTitle,
                "py-x8 md-py-x16 fs-4 md-fs-2 fw-bold text-slate-28",
              )}
            >
              {titleSection}
            </TitleTag>
            {subtitle && <div>{subtitle}</div>}
          </div>
          {gotoLinkHref && gotoLinkLabel && (
            <div className="ui-title-goto-link">
              <ArrowLink href={gotoLinkHref} asLink={gotoLinkAsLink} fs="7">
                {gotoLinkLabel.toUpperCase()}
              </ArrowLink>
            </div>
          )}

          {popupActions.length === 2 && (
            <>
              <div
                onClick={() => setOpenActions(!openActions)}
                className="ui-mobile-actions"
              >
                <MoreActions
                  className="cursor-pointer"
                  aria-label="Altre opzioni"
                />
              </div>
              <ActionsPopup
                isOpen={openActions}
                onClickCloseBtn={() => setOpenActions(false)}
                actions={popupActions}
                className="ui-mobile-actionspopup"
              >
                {secondaryButton && (
                  <div className="ui-actions-popup-buttons">
                    {secondaryButton}
                  </div>
                )}
              </ActionsPopup>
            </>
          )}
        </div>

        {popupActions.length === 1 && (
          <div className="ui-mobile-single-action">{popupActions[0]}</div>
        )}

        <nav className="ui-desktop-actions" aria-label="Azioni principali">
          <Row
            as={"ul"}
            gap={"x20"}
            fw={"semibold"}
            text={"primary"}
            fs={"8"}
            className="list-style-none"
          >
            {action1}
            {action2 && <span className="ui-divider-title-section"></span>}
            {action2}
            {secondaryButton && (
              <Row
                as={"li"}
                text={"primary"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={"x8"}
              >
                {secondaryButton}
              </Row>
            )}
            {mainButton && (
              <Row
                as={"li"}
                text={"primary"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={"x8"}
              >
                {mainButton}
              </Row>
            )}
          </Row>
        </nav>
      </div>
      <div className="ui-mobile-main-button">{mainButton}</div>
    </div>
  );
};
